<template>
  <div>
    <ListingTable :columnCount="5">
      <template v-slot:thead>
        <thead>
          <tr>
            <th class="simple-table-th">#</th>
            <th class="simple-table-th">Name</th>
            <th class="simple-table-th">Available Weeks</th>
            <th class="simple-table-th">Price</th>
            <th class="simple-table-th">Price Type</th>
          </tr>
        </thead>
      </template>
      <template v-slot:tbody>
        <tbody class="custom-border-bottom">
          <template v-if="availableWeek?.length > 0">
            <tr class="alternate-listing-row" v-for="(row, index) in availableWeek" :key="index">
              <!-- Index -->
              <td class="simple-table-td">{{ index + 1 }}</td>

              <!-- Name -->
              <td class="simple-table-td">
                <span v-if="row?.name">{{ row?.name }}</span>
                <em v-else class="text-muted">—</em>
              </td>

              <!-- Week Availability -->
              <td class="simple-table-td">
                <span v-if="row?.WeekAvailable && row?.WeekAvailable.length">
                  <span v-for="(week, wIndex) in row?.WeekAvailable" :key="wIndex">
                    <span v-if="week?.available">
                      <v-chip small class="ml-1">
                        {{ week?.name }}
                      </v-chip>
                    </span>
                  </span>
                </span>
                <em v-else class="text-muted">No week available</em>
              </td>

              <!-- Price -->
              <td class="simple-table-td">
                <template v-if="index === 0 && row?.price && row?.twice_weekly_price">
                  ${{ row?.price }} / ${{ row?.twice_weekly_price }}
                </template>
                <template v-else-if="row?.price">
                  ${{ row?.price }}
                </template>
                <em v-else class="text-muted">no price</em>
              </td>

              <!-- Price Type -->
              <td class="simple-table-td">
                <template v-if="index === 0 && row?.priceType && row?.twice_weekly_price_type">
                  {{ row?.priceType }} / {{ row?.twice_weekly_price_type }}
                </template>
                <template v-else-if="row?.price">
                  {{ row?.priceType }}
                </template>
                <em v-else class="text-muted">no price type</em>
              </td>

            </tr>
          </template>

          <tr v-else>
            <td colspan="6" class="py-4">
              <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
                <img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
                Uhh... There are no week availability at the moment.
              </p>
            </td>
          </tr>
        </tbody>
      </template>
    </ListingTable>
  </div>
</template>
<script>
import { GET } from "@/core/services/store/request.module";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
export default {
  data() {
    return {
      availableWeek: [],
      viewSlots: false,
    };
  },

  components: {
    ListingTable,
  },
  methods: {
    getWeekAvailable() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "get-week-availability/" + _this.service_id,
        })
        .then(({ data }) => {
          _this.availableWeek = data;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  mounted() {
    this.service_id = this.$route.params?.id;
    this.getWeekAvailable();
  },
};
</script>
